import React from "react";

function Legenda() {
  return (
    <div className="legenda uk-position-absolute">
      <ul className="uk-list uk-margin-remove">
        <li className="vendita">Vendita con Agente</li>
        <li className="affitto">Affitto con Agente</li>
        <li className="privati">Privati</li>
      </ul>
    </div>
  );
}

export default Legenda;
